import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ActiveDirectoryService } from 'src/app/private/services/activedirectoryconfig.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-delete-active-directory-config',
  imports: [SharedModule],
  templateUrl: './delete-active-directory-config.component.html',
  styleUrl: './delete-active-directory-config.component.scss'
})
export class DeleteActiveDirectoryConfigComponent {
@Input() activeDirectoryDataToEdit: any = null;
  @Input() clientId: string = '';
  isLoading = false;

  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  constructor(
    private activeDirectoryConfig: ActiveDirectoryService,
    private messageService: MessageService
  ) { }


  handleCloseDialog() {
    this.close.emit();
  }

  handleDeleteDepartment() {
    this.isLoading = true; // Set loading state to true
    const payload = {
      id: this.activeDirectoryDataToEdit.id,
    };
    this.activeDirectoryConfig.deleteActiveDirectoryConfig(payload).subscribe(
      {
        next: (res: any) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Department deleted successfully'
          });
          this.reload.emit(); // Emit reload event to parent component
          this.close.emit(); // Emit close event to parent component
        },
        error: (err) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err.error?.message || 'An error occurred while deleting the department'
          });
        }
      }
    );
  }
}
